import { createSelector } from 'reselect';
import { getFileInfoState } from './getFileInfoState';
import { FileUploadStatus } from '../enums';
export const getFileUploadCanceledCount = createSelector([getFileInfoState], (state) => {
    let count = 0;
    for (let i = 0; i < state.allIds.length; i++) {
        const fileInfo = state.byId[state.allIds[i]];
        if (fileInfo.uploadStatus === FileUploadStatus.CANCELLED && fileInfo.parentId === undefined) {
            count++;
        }
    }
    return count;
});
//# sourceMappingURL=getFileUploadCanceledCount.js.map